import CommitteeUsersNew from './CommitteeUsersNew'
import CommitteeUsersEdit from './CommitteeUsersEdit'
import Main from './CommitteesMain'
import Show from './CommitteesShow'

export default {
  CommitteeUsersEdit,
  CommitteeUsersNew,
  Main,
  Show,
}
